const getters = {
  userInfo: state => state.user.userInfo,
  isLogin: state => state.user.isLogin,
  user_type: state => state.user.user_type,


}
export default getters
